import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as ChatConstants from './ChatConstants';

export function getChatData(domain) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.CHAT_DATA)}/${domain}`,
      types: [
        ChatConstants.GET_CHAT_DATA_REQUEST,
        ChatConstants.GET_CHAT_DATA_SUCCESS,
        ChatConstants.GET_CHAT_DATA_FAILED
      ]
    }
  };
}

export function sendChatMessage(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post'
      },
      endpoint: `${apiEndpoints().entity(API.CHAT_DATA)}`,
      types: [
        ChatConstants.ADD_CHAT_MESSAGE_REQUEST,
        ChatConstants.ADD_CHAT_MESSAGE_SUCCESS,
        ChatConstants.ADD_CHAT_MESSAGE_FAILED
      ]
    }
  };
}

export function discardQC(domainId) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.DISCARD_QC)}/${domainId}`,
      types: [
        ChatConstants.DISCARD_QC_REQUEST,
        ChatConstants.DISCARD_QC_SUCCESS,
        ChatConstants.DISCARD_QC_FAILED
      ]
    }
  };
}

export function discardFR(domainId) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.DISCARD_FR)}/${domainId}`,
      types: [
        ChatConstants.DISCARD_FR_REQUEST,
        ChatConstants.DISCARD_FR_SUCCESS,
        ChatConstants.DISCARD_FR_FAILED
      ]
    }
  };
}
